<template>
  <div class="wh100">
    <xh-filter-layout title="光辉历程管理">
      <template slot="filter">
        <el-form :inline="true" size="medium">
          <el-form-item>
            <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
          <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
          <el-table-column prop="about_name" label="标题/名称" align="center"  sortable></el-table-column>
          <el-table-column prop="update_time" label="更新时间" align="center" sortable></el-table-column>
          <el-table-column prop="sort" label="排序" align="center" sortable></el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="修改" placement="top">
                <el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top">
                <el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </MyTable>
      </template>
    </xh-filter-layout>
    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="55%" height="70%" :close-on-click-modal="false" @closed="closeModal">
      <HistoryEdit ref="editRef" :key="timer" :data="dialog.editRow" @closeModal="closeModal" center></HistoryEdit>
    </xh-dialog>
  </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import HistoryEdit from "./components/HistoryEdit";
export default{
  components: { XhFilterLayout, MyPanel, MyTable,HistoryEdit},
  data(){
    return{
      title:'GloriousHistory',
      form: {},
      table: {
        method: "POST",
        url: "/GloriousHistory/getData",
        pageSize: 50,
      },
      checkRowId: [],
      timer:"",
      dialog: {
        title: "添加",
        visible: false,
        editRow: {}
      },
    }
  },
  methods:{
    query(){
      this.$refs.mytable.reload();
    },
    edit(row) {
      let that = this;
      that.timer = new Date().getTime();
      if (row == null) {
        that.dialog.title = "添加";
        that.dialog.editRow = {
          id: that.$util.guid(),
          about_name: "",
          about_content: null,
          about_type:"AT03",
          flag: 0,//新增
        };
      } else {
        that.dialog.title = "修改";
        that.dialog.editRow = row;
        that.dialog.editRow.flag = 1;//修改
      }

      that.dialog.visible = true;
    },
    //关闭弹出页面
    closeModal() {
      this.dialog.visible = false;
      this.$nextTick(function () { this.query(); });
    },
    deleteRow(row) {
      let that = this;
      that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", {confirmButtonText: "确定", cancelButtonText: "取消", type: "warning"})
          .then(() => {
            that.$api.post("/GloriousHistory/deleteData", {id: row.id},
                function (res) {
                  if (res.code === "200") {
                    that.query();
                    that.$message.success("删除成功");
                  } else {
                    that.$message.error("删除失败");
                  }
                },
                function (res) {
                  //that.$message.error("服务器异常，删除出错");
                }
            );
          })
          .catch(() => {
          });

    },
  },
  computed: { },
  mounted() { },
  created() { },
  watch: { },
}


</script>
